import { Component, EventEmitter, forwardRef, Input, Output, ViewEncapsulation } from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormField } from '@app/shared/models/field.interface';
import { BaseControl } from './../../base-control';

@Component({
  selector: 'vfs-input-number',
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputNumberComponent),
    },
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class InputNumberComponent extends BaseControl {
  @Input() field: FormField;
  @Input() readonly: boolean;
  @Input() min: number;
  @Input() max: number;
  @Input() maxLength = 255;
  @Input() width = '220px';
  @Input() error: string;
  @Input() autocomplete: string;
  @Input() autofocus = false;
  @Input() disabled: boolean;
  // No Form
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() hint?: string;
  @Input() formControl: FormControl;
  @Input() required: boolean;
  @Input() tooltip?: string;
  @Output() change = new EventEmitter();
}
